module.exports = __webpack_public_path__ + "static/media/ps4.557fc7f3.jpg";